import "./App.css";
import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { RouterProvider } from "react-router-dom";

import KMKSnackbar from "./component/kmk/Notification";
import { hideToast } from "./store/actions";
import Route from "./route";
import useUnload from "./util/useUnload";

const mdTheme = createTheme({
  palette: {
    primary: {
      light: "#ff9800",
      main: "#3a3d4a",
      dark: "#e65100",
    },
    secondary: {
      light: "#90a4ae",
      main: "#3a3d4a",
      dark: "#263238",
      text: "#f5f5f5",
    },
    TiffanyBlue: {
      main: "#e8edf1",
    },
    dark: {
      light: "#637282",
      main: "#373f48",
      dark: "#0b0d0e",
      text: "#fff",
    },
    success: {
      light: "#B4CAB6",
      main: "#1B5E20",
      dark: "#0E3011",
    },
  },
});

function App() {
  //For Toastes
  const { message, type = "primary", visible } = useSelector((state) => state.toast);
  const runningProcesses = useSelector((state) => state.runningProcesses);
  const processQueue = useSelector((state) => state.processQueue);

  const dispatch = useDispatch();

  useUnload((e) => {
    if (
      runningProcesses.filter((process) => process.runningProcesses).length ||
      processQueue.inProgress ||
      processQueue.currentQueue.length
    ) {
      e.preventDefault();
      e.returnValue = "";
    } else return undefined;
  });

  return (
    <ThemeProvider theme={mdTheme}>
      <RouterProvider router={Route} />
      {visible && <KMKSnackbar message={message} type={type} open={visible} onClose={() => dispatch(hideToast())} />}
    </ThemeProvider>
  );
}

export default App;
